import { getLanguageCode } from '../platform';

export const DEFAULT_LANG = 'en';

export const SUPPORTED_LOCALES = [
  { code: 'en', nativeName: 'English', flag: '🇬🇧', shortCode: 'EN' },
  { code: 'ru', nativeName: 'Русский', flag: '🇷🇺', shortCode: 'RU' },
  { code: 'es', nativeName: 'Español', flag: '🇪🇸', shortCode: 'ES' },
  { code: 'pt-BR', nativeName: 'Português', flag: '🇧🇷', shortCode: 'PT' },
  { code: 'hi', nativeName: 'हिन्दी', flag: '🇮🇳', shortCode: 'HI' },
  { code: 'id', nativeName: 'Bahasa Indonesia', flag: '🇮🇩', shortCode: 'ID' },
  { code: 'tr', nativeName: 'Türkçe', flag: '🇹🇷', shortCode: 'TR' },
  { code: 'ko', nativeName: '한국어', flag: '🇰🇷', shortCode: 'KO' },
];

const SUPPORTED_CODES = new Set(SUPPORTED_LOCALES.map(({ code }) => code));

const LANGUAGE_ALIASES = {
  uk: 'ru',
  be: 'ru',
  kk: 'ru',
  uz: 'ru',
  ky: 'ru',
  tg: 'ru',
  az: 'ru',
  hy: 'ru',
  ka: 'ru',
  mn: 'ru',
};

const findSupportedLocale = (value = '') => {
  const normalized = String(value).trim().replace(/_/g, '-').toLowerCase();
  if (!normalized) return null;

  const base = normalized.split('-')[0];
  if (base === 'pt') return 'pt-BR';
  if (base === 'es') return 'es';
  if (LANGUAGE_ALIASES[base]) return LANGUAGE_ALIASES[base];

  return SUPPORTED_CODES.has(base) ? base : null;
};

export const normalizeLanguageCode = (value, fallback = DEFAULT_LANG) =>
  findSupportedLocale(value) || fallback;

export const resolveLocale = ({
  userLanguage,
  telegramLanguage,
  deviceLanguages = [],
} = {}) => {
  if (userLanguage) return normalizeLanguageCode(userLanguage);

  const telegramLocale = findSupportedLocale(telegramLanguage);
  if (telegramLocale) return telegramLocale;

  for (const language of deviceLanguages) {
    const deviceLocale = findSupportedLocale(language);
    if (deviceLocale) return deviceLocale;
  }

  return DEFAULT_LANG;
};

export const getLocale = (userLanguage = null) =>
  resolveLocale({
    userLanguage,
    telegramLanguage: getLanguageCode(),
    deviceLanguages: [
      ...(navigator.languages || []),
      navigator.language,
      navigator.userLanguage,
    ],
  });

export default SUPPORTED_LOCALES;
